import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCyT1BIIeYwy-Edk3I59gDYMEhlrueW034",
  authDomain: "mindgame-33c85.firebaseapp.com",
  databaseURL:
    "https://mindgame-33c85-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "mindgame-33c85",
  storageBucket: "mindgame-33c85.appspot.com",
  messagingSenderId: "279948774327",
  appId: "1:279948774327:web:c1dba3a2802f978278b632",
};

const app = initializeApp(firebaseConfig);

// Get a reference to the database service
const database = getDatabase(app);

export default database;
